import { phoneNumber, password, verificationCode } from "@/validator/validator";
export default {
  data() {
    return {
      loginForm: {
        phoneNumber: "",
        password: "",
        code: "",
        rememberMe: false
      },

      loginRules: {
        phoneNumber: phoneNumber,
        password: password,
        code: verificationCode
      }
    };
  },

  methods: {
    verifyLoginForm(name) {
      this.$refs[name].validate(valid => {
        if (!valid) return false;
        this.handleLogin();
      });
    },

    loginSuccess() {
      this.$Message.success("登陆成功！");
      this.$router.push({ path: "/entry/select" });
    }
  }
};
